module.exports = __webpack_public_path__ + "static/media/close-solid.9003af81.svg";